<template>
  <div class="mt-2 mb-1">
    <b-row>
      <div class="col text-left">
        <h3>Report Management</h3>
      </div>
    </b-row>
    <b-row class="text-left flex-nowrap">
      <b-col cols="4">
        <div>
          <div class="text-right mb-2">
            <b-btn variant="info" class="text-nowrap mr-1" @click="copyModel" v-if="listDisplayedModelsIndexes.length === 1 && listModifiedModelsIndexes.length <= 0">Copy</b-btn>
            <b-btn variant="info" class="text-nowrap mr-1" @click="addModel(null)" v-if="listModifiedModelsIndexes.length <= 0">Add</b-btn>
            <b-btn variant="outline-info" @click="refreshDataFromBackend">Refresh</b-btn>
          </div>
        </div>
        <div class="scrollable-table-wrapper">
          <div class="scr-tbl-cont vh-h-80">
            <table class="table text-center">
              <thead class="header">
              <tr class="cursor-pointer">
                <th @click="doSortFilteredData('ats.Name')" class="pct-w-45">
                  Name
                  <span v-if="filtersSorter.ascending && filtersSorter.field === 'ats.Name'">&uArr;</span>
                  <span v-if="!filtersSorter.ascending && filtersSorter.field === 'ats.Name'">&dArr;</span>
                </th>
                <th @click="doSortFilteredData('ats.Source')" colspan="2" class="pct-w-55">
                  Source
                  <span v-if="filtersSorter.ascending && filtersSorter.field === 'ats.Source'">&uArr;</span>
                  <span v-if="!filtersSorter.ascending && filtersSorter.field === 'ats.Source'">&dArr;</span>
                </th>
              </tr>
              <tr>
                <th class="pct-w-45">
                  <b-form-group>
                    <b-form-select v-model="filterSelectedFields.Name" :disabled="listModifiedModelsIndexes.length > 0">
                      <option :value="null">All</option>
                      <option v-for="item of filterLists.Names" :key="item" :value="item">{{ item }}</option>
                    </b-form-select>
                  </b-form-group>
                </th>
                <th class="pct-w-45">
                  <b-form-group>
                    <b-form-select v-model="filterSelectedFields.Source" :disabled="listModifiedModelsIndexes.length > 0">
                      <option :value="null">All</option>
                      <option v-for="item of filterLists.Sources" :key="item" :value="item">{{ item | reportFieldSource }}</option>
                    </b-form-select>
                  </b-form-group>
                </th>
                <th class="pct-w-10">
                  <b-form-group>
                    <b-btn
                        size="sm"
                        title="Clear filters"
                        variant="danger"
                        @click="doFilterReset()"
                        :disabled="listModifiedModelsIndexes.length > 0"
                        class="mr-2"
                    >&#9003;
                    </b-btn>
                  </b-form-group>
                </th>
              </tr>
              </thead>
              <tbody v-if="filteredCollection.length">
              <tr
                  v-for="(model, i) in filteredCollection"
                  :key="model.ats.Id"
                  @click="showOneModel(i)"
                  class="cursor-pointer"
                  :class="{
                                'selected': listDisplayedModelsIndexes.includes(i)
                            }"
              >
                <td class="text-wrap pct-w-45" style="word-wrap: break-word">{{ model.ats.Name || '---' }}</td>
                <td colspan="2" class="text-wrap pct-w-55" style="word-wrap: break-word">{{ model.ats.Source | reportFieldSource }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-col>
      <b-col>
        <div v-for="index in listDisplayedModelsIndexes" :key="filteredCollection[index].Id + '_' + index">
          <model-table
              :model="filteredCollection[index]"
              :index="index"
              @onModelDeleted="onModelDeleted"
              @freezeWorkflow="freezeWorkflow"
              @unFreezeWorkflow="unFreezeWorkflow"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service                                                        from '@/services/HttpRequestService';
import {arrayClear, arrayElInsertAt, arrayElRemoveByIndex, sortArray} from '@/utilities/ArrayUtils';
import ModelTable                                                     from './ModelTable';
import mReport                                                        from "@/models/mReport";
import ManagerRequest                                                 from "@/services/ManagerRequest";

export default {
  data() {
    return {
      allCollection:              [],
      filteredCollection:         [],
      listDisplayedModelsIndexes: [],
      listModifiedModelsIndexes:  [],
      listIdDisplayed:            [],
      listIdModified:             [],
      filterLists:                {
        Ids:     [],
        Names:   [],
        Sources: []
      },
      filterSelectedFields:       {
        Id:     null,
        Name:   null,
        Source: null
      },
      filtersSorter:              {
        field:     'ats.Name',
        ascending: true
      },
      alert:                      {
        timestamp: 0,
        type:      '',
        msg:       ''
      },
      flagChangesNotSaved:        false,
      flagApplyFilter:            false,
      fixedPreviousModelId:       null,
      fixedNextModelId:           null
    };
  },
  async created() {
    await this.getCollection();
    await this.doFilterReset();
  },
  watch:      {
    // ###############
    // region Filters
    'filterSelectedFields.Id'() {
      this.doFilterApply();
    },
    'filterSelectedFields.Name'() {
      this.doFilterApply();
    },
    'filterSelectedFields.Source'() {
      this.doFilterApply();
    }
    // endregion Filters
    // ###############
  },
  methods:    {
    loopAllCollection() {
      // #####
      let modelId                   = null;
      let indexInFilteredCollection = null;
      if (this.listDisplayedModelsIndexes.length > 0) {
        indexInFilteredCollection = this.listDisplayedModelsIndexes[0];
        modelId                   = this.getModelIdByIndexInFilteredCollection(indexInFilteredCollection);
      }
      // #####
      this.filteredCollection = [];
      // #####
      const oIds              = {};
      const oNames            = {};
      const oSources          = {};
      // ##################################################
      for (let [i, model] of Object.entries(this.allCollection)) {
        if (!(model instanceof mReport)) {
          model = new mReport(model);
        }
        this.allCollection[i] = model;
        if (this.flagApplyFilter) {
          // ###############
          // region Filter
          if (
              (this.filterSelectedFields.Id === null || this.filterSelectedFields.Id == model.ats.Id) &&
              (this.filterSelectedFields.Name === null || this.filterSelectedFields.Name == model.ats.Name) &&
              (this.filterSelectedFields.Source === null || this.filterSelectedFields.Source == model.ats.Source)
          ) {
            this.filteredCollection.push(model);
            if (model.ats.Id) oIds[model.ats.Id] = 1;
            if (model.ats.Name) oNames[model.ats.Name] = 1;
            if (model.ats.hasOwnProperty('Source')) oSources[model.ats.Source] = 1;
          }
          // endregion Filter
          // ###############
        } else {
          this.filteredCollection.push(model);
          if (model.ats.Id) oIds[model.ats.Id] = 1;
          if (model.ats.Name) oNames[model.ats.Name] = 1;
          if (model.hasOwnProperty('Source')) oSources[model.ats.Source] = 1;
        }
      }
      // ##################################################
      this.filteredCollection  = sortArray(this.filteredCollection, this.filtersSorter.ascending, this.filtersSorter.field);
      this.filterLists.Ids     = sortArray(Object.keys(oIds));
      this.filterLists.Names   = sortArray(Object.keys(oNames));
      this.filterLists.Sources = sortArray(Object.keys(oSources));
      // #####
      this.showOneModelById(modelId);
    },
    doFilterApply(flagApplyFilter = true) {
      this.flagApplyFilter = flagApplyFilter;
      this.loopAllCollection();
    },
    async doFilterReset(flagApplyFilter = false) {
      if (!await this.modifiedListOkayToProceed()) return;
      this.filtersClear();
      this.doFilterApply(flagApplyFilter);
    },
    filtersClear() {
      for (let f of Object.keys(this.filterSelectedFields)) {
        this.filterSelectedFields[f] = null;
      }
    },
    doSortFilteredData(field) {
      const ascending              = this.filtersSorter.field === field
                                     ? !this.filtersSorter.ascending
                                     : true;
      this.filtersSorter.field     = field;
      this.filtersSorter.ascending = ascending;
      this.doFilterApply();
    },
    async refreshDataFromBackend() {
      if (!await this.modifiedListOkayToProceed()) return;
      await this.getCollection();
      arrayClear(this.listDisplayedModelsIndexes)
      arrayClear(this.listIdModified)
      await this.doFilterReset();
    },
    addModel(newModel = null) {
      if (newModel === null) {
        newModel = new mReport();
      }
      arrayElInsertAt(this.allCollection, newModel, 0);
      arrayElInsertAt(this.filteredCollection, newModel, 0);
      this.showOneModel(0);
      this.listModifiedModelsIndexes = [0];
    },
    async copyModel() {
      if (!await this.modifiedListOkayToProceed()) return;
      const currentModel          = this.getCurrentModel();
      const rawFieldsCurrentModel = currentModel.getRawFields();
      rawFieldsCurrentModel.Id    = 0;
      const newModel              = new mReport(rawFieldsCurrentModel);
      this.addModel(newModel);
      //this.$set(newModel, '_localForceUnfreezeWorkflow', false);
      this.$set(newModel.ats, 'Name', `${newModel.ats.Name} - COPY`);
    },
    async showOneModel(indexInFilteredCollection) {
      if (this.listDisplayedModelsIndexes.includes(indexInFilteredCollection)) {
        return;
      }
      const model = this.filteredCollection[indexInFilteredCollection];
      if (!await this.modifiedListOkayToProceed()) return;
      if (!model.isNew()) {
        await model.get();
        this.showOneModelById(model.ats.Id);
      } else {
        this.listDisplayedModelsIndexes = [indexInFilteredCollection];
      }
    },
    showOneModelById(modelId) {
      const indexInFilteredCollection = this.getIndexInFilteredCollectionByModelId(modelId);
      if (indexInFilteredCollection !== null) {
        this.listDisplayedModelsIndexes = [indexInFilteredCollection];
        // #####
        // Fix to pre-save changed model.
        if (this.listModifiedModelsIndexes.length > 0) {
          this.listModifiedModelsIndexes = [indexInFilteredCollection];
        }
        // #####
      } else {
        this.listDisplayedModelsIndexes = [];
      }
      return this;
    },
    freezeWorkflow(indexInFilteredCollection) {
      this.listModifiedModelsIndexes = [indexInFilteredCollection];
    },
    unFreezeWorkflow() {
      arrayClear(this.listModifiedModelsIndexes);
    },
    async modifiedListOkayToProceed() {
      // #####
      // Fix to prevent leave of un-saved model.
      if (this.listDisplayedModelsIndexes.length > 0) {
        const idx           = this.listDisplayedModelsIndexes[0];
        const previousModel = this.filteredCollection[idx];
        if (previousModel.isNew()) {
          this.listModifiedModelsIndexes = [idx];
        }
      }
      // #####
      if (this.listModifiedModelsIndexes.length > 0) {
        if (await this.$root.confirmCurrentStep('Current Model is modified. Discard changes?')) {
          const indexInFilteredCollection = this.listModifiedModelsIndexes[0];
          const previousModel             = this.filteredCollection[indexInFilteredCollection];
          previousModel.revert();
          // #####
          if (previousModel.isNew()) {
            this.onModelDeleted(indexInFilteredCollection);
          }
          // #####
          this.unFreezeWorkflow();
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    async getCollection() {
      this.allCollection = await (new ManagerRequest(
          service.getReportsList,
          service,
          this.allCollection
      ))
      .do();
    },
    onModelDeleted(indexInFilteredCollection) {
      const modelId              = this.filteredCollection[indexInFilteredCollection].Id;
      const indexInAllCollection = this.allCollection.findIndex(el => el.Id == modelId);
      arrayElRemoveByIndex(this.allCollection, indexInAllCollection);
      arrayElRemoveByIndex(this.filteredCollection, indexInFilteredCollection);
      this.listDisplayedModelsIndexes = [];
      this.listModifiedModelsIndexes  = [];
      // this.getCollection();
      // this.doFilterApply();
    },
    getModelIdByIndexInFilteredCollection(indexInFilteredCollection) {
      let modelId = null;
      if (this.filteredCollection[indexInFilteredCollection]) {
        const model = this.filteredCollection[indexInFilteredCollection];
        modelId     = model.ats.Id;
      }
      return modelId;
    },
    getIndexInFilteredCollectionByModelId(modelId) {
      let indexInFilteredCollection = null;
      let res                       = this.filteredCollection.findIndex(el => el.ats.Id == modelId);
      if (res !== -1) {
        indexInFilteredCollection = res;
      }
      return indexInFilteredCollection;
    },
    getCurrentModel() {
      const indexInFilteredCollection = this.listDisplayedModelsIndexes[0];
      const currentModel              = this.filteredCollection[indexInFilteredCollection];
      return currentModel;
    }
  },
  components: {
    ModelTable
  }
};
</script>

<style lang="scss" scoped>
</style>
